import { atom } from 'jotai'
import { atomWithImmer } from 'jotai-immer'
import { BlindKaizoRace } from '../types/raceTypes';

interface NextLastRaces {
	lastRace?: any,
	nextRace?: any,
	isLoaded: boolean
}

export const nextLastRacesAtom = atom<NextLastRaces>({
    isLoaded: false,
    lastRace: undefined,
    nextRace: undefined
})

export const updateNextLastRacesAtom = atom(null, (get, set, newRaces: NextLastRaces) => {
    set(nextLastRacesAtom, newRaces)
})

export const isLastRaceLoaded = atom((get) => get(nextLastRacesAtom).isLoaded)
export const lastRaceAtom = atom((get) => get(nextLastRacesAtom).lastRace)
export const nextRaceAtom = atom((get) => get(nextLastRacesAtom).nextRace)

export const raceTypes = atom([
    {
        name: 'Blind Races',
        slug: 'blindKaizo'
    },
    {
        name: 'Mystery Monday',
        slug: 'mysteryMonday'
    }
])

export const blindKaizoRacesAtom = atomWithImmer<BlindKaizoRace[]>([])

export const updateBlindKaizoRacesAtom = atom(null, (get, set, races: BlindKaizoRace[]) => {
    set(blindKaizoRacesAtom, races)
})